export default __webpack_public_path__ + "static/media/loja2.3ecb8edd.jpeg";